import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { ICapexProgress } from './interfaces';

export const getCapexProgressList = (data: IDynamicTableParams) => {
  return instance()
    .post<ICapexProgress[]>('/capex/progress/list', data)
    .then((response) => response.data);
};

export const getCapexProgressAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/capex/progress/availableColumns')
    .then((response) => response.data);
};

export const getCapexProgressAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/capex/progress/availableGroupColumns')
    .then((response) => response.data);
};

export const getCapexProgressListAllNotDeleted = () => {
  return instance()
    .post<ICapexProgress[]>('/capex/progress/listAllNotDeleted')
    .then((response) => response.data);
};

export const loadCapexProgress = (progressId: number) => {
  return instance()
    .get<ICapexProgress>('/capex/progress/load/' + progressId)
    .then((response) => response.data);
};

export const createCapexProgress = (capexProgress: ICapexProgress) => {
  return instance()
    .post<ICapexProgress>('/capex/progress/save', capexProgress)
    .then((response) => response.data);
};

export const updateCapexProgress = (capexProgress: ICapexProgress) => {
  return instance()
    .post<ICapexProgress>(`/capex/progress/${capexProgress.progressId}/update`, capexProgress)
    .then((response) => response.data);
};

export const archiveCapexProgress = (progressId: number) => {
  return instance()
    .post(`/capex/progress/archive`, { progressId })
    .then((response) => response.data);
};

export const recoverCapexProgress = (progressId: number) => {
  return instance()
    .post(`/capex/progress/recover`, { progressId })
    .then((response) => response.data);
};

